/* eslint-disable no-console */
import {select, SelectEffect} from "redux-saga/effects";
import {RootState} from "../reducers/interface";

export type GetReduxStateGeneratorType = Generator<SelectEffect, RootState, RootState>;
export function* getReduxState(): GetReduxStateGeneratorType {
    return (yield select((state: RootState) => state)) as RootState;
}
